import * as AllColors from '../constants/colors';

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj['default'] = 'default';
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'invert';
  obj['default'] = 'default';
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'default';
  obj[AllColors['COLOR_NEUTRAL2']] = 'default';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createChipMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'default';
  obj[AllColors['COLOR_NEUTRAL2']] = 'default';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_RED500']] = 'white';
  obj[AllColors['COLOR_GREY100']] = 'white';
  obj['default'] = 'white';
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj['default'] = 'white';
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'invert';
  obj[AllColors['COLOR_NEUTRAL2']] = 'invert';
  obj[AllColors['COLOR_EON_NEUTRAL2']] = 'invert';
  obj[AllColors['COLOR_EON_PRIMARY2']] = 'invert';
  obj['default'] = 'default';
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj['default'] = 'default';
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj['default'] = 'default';
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_NEUTRAL100']] = 'neutral800';
  obj[AllColors['COLOR_WHITE']] = 'grey900';
  obj[AllColors['COLOR_NEUTRAL300']] = 'neutral800';
  obj[AllColors['COLOR_GREY100']] = 'grey900';
  obj[AllColors['COLOR_RED500']] = 'white';
  obj[AllColors['COLOR_RED100']] = 'neutral800';
  obj[AllColors['COLOR_RED300']] = 'neutral800';
  obj[AllColors['COLOR_YELLOW100']] = 'neutral800';
  obj[AllColors['COLOR_YELLOW300']] = 'neutral800';
  obj[AllColors['COLOR_TURQUOISE100']] = 'neutral800';
  obj[AllColors['COLOR_TURQUOISE300']] = 'neutral800';
  obj[AllColors['COLOR_GREY900']] = 'white';
  obj['default'] = 'neutral800';
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'invert';
  obj['default'] = 'default';
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_BRIGHT_WHITE']] = 'mellowYellowBright';
  obj[AllColors['COLOR_ATMOSPHERIC_ANTHRACITE5']] = 'atmosphericAnthracite';
  obj[AllColors['COLOR_ATMOSPHERIC_ANTHRACITE25']] = 'atmosphericAnthracite';
  obj['default'] = 'brightWhite';
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_NEUTRAL1']] = 'default';
  obj[AllColors['COLOR_NEUTRAL3']] = 'default';
  obj[AllColors['COLOR_NEUTRAL4']] = 'default';
  obj[AllColors['COLOR_NEUTRAL5']] = 'default';
  obj[AllColors['COLOR_NEUTRAL7']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_SECONDARY1']] = 'default';
  obj[AllColors['COLOR_SECONDARY2']] = 'default';
  obj[AllColors['COLOR_SECONDARY3']] = 'default';
  obj[AllColors['COLOR_SECONDARY4']] = 'default';
  obj[AllColors['COLOR_SECONDARY5']] = 'default';
  obj[AllColors['COLOR_SECONDARY6']] = 'default';
  obj[AllColors['COLOR_SECONDARY7']] = 'default';
  obj[AllColors['COLOR_SECONDARY8']] = 'default';
  obj[AllColors['COLOR_SECONDARY9']] = 'default';
  obj[AllColors['COLOR_SECONDARY10']] = 'default';
  obj[AllColors['COLOR_SECONDARY11']] = 'default';
  obj[AllColors['COLOR_SECONDARY12']] = 'default';
  obj[AllColors['COLOR_SECONDARY13']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_NEUTRAL100']] = 'red500';
  obj[AllColors['COLOR_WHITE']] = 'red500';
  obj[AllColors['COLOR_NEUTRAL300']] = 'red500';
  obj[AllColors['COLOR_GREY100']] = 'red500';
  obj[AllColors['COLOR_RED500']] = 'white';
  obj['default'] = 'red500';
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY1']] = 'invert';
  obj['default'] = 'default';
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_PRIMARY2']] = 'invert';
  obj[AllColors['COLOR_NEUTRAL2']] = 'invert';
  obj['default'] = 'default';
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj[AllColors['COLOR_PRIMARY2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL2']] = 'inverse';
  obj[AllColors['COLOR_NEUTRAL9']] = 'default';
  obj[AllColors['COLOR_NEUTRAL8']] = 'default';
  obj['default'] = 'default';
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj['default'] = 'default';
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj['default'] = 'default';
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
